


import spartaBootstrapUtility from "@sparta.global.utilities/sparta-bootstrap-utility/dist/es6.js"
import tagManagerUtility from "@sparta.global-vtim.utilities/tag-manager-utility/dist/es6.js"
import syncTaggingUtility from "@sparta.global-vtim.utilities/sync-tagging-utility/dist/es6.js"



window.spaParams = window.spaParams || {};
window.spaParams.dynamicImportMap = {
  modules: [
    {
      name: "@sparta.global.vendors/vue",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/vendors/vue" */ "@sparta.global.vendors/vue" )}
    },
    {
      name: "@sparta.global.vendors/vuex",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/vendors/vuex" */ "@sparta.global.vendors/vuex" )}
    },
    {
      name: "@sparta.global.vendors/vue-router",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/vendors/vue-router" */ "@sparta.global.vendors/vue-router" )}
    }
  ],
  sharedComponents: [
    {
      name: "@sparta.global.shared-components/global-render-sparta-helper-vue3-comp",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/global-global-render-sparta-helper-vue3-comp-es6" */ "@sparta.global.shared-components/global-render-sparta-helper-vue3-comp/dist/es6.js" )}
    },
    {
      name: "@sparta.global.shared-components/spa-vue-show-hide",
      loader: function() { return import( /* webpackChunkName: "spa-assets/js/shared-components/global-spa-vue-show-hide-es6" */ "@sparta.global.shared-components/spa-vue-show-hide/dist/es6.js" )}
    }
  ],
  stores: [
    {
      namespace: "@sparta.universal-preapplication-consumer.stores/upac-store",
                   loader: function() { return import( /* webpackChunkName: "spa-assets/js/stores/@sparta.universal-preapplication-consumer.stores/upac-store-es6" */ "@sparta.universal-preapplication-consumer.stores/upac-store/dist/es6.js" )}
    }
  ],
}




// Add fingerprint spa-map.json into spaParams

// Initialize page
;(async function() {
  console.log('INIT PAGE')
  console.log('before - execute boot functions')
  await spartaBootstrapUtility.init(arguments);
  console.log('after - execute boot functions')
})();
